import { Trans, useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';
import { CrownRoundedIcon } from '../../../components/SVGIcons/CrownRoundedIcon';
import { SweepCoin } from '../../../components/SweepCoin/SweepCoin';
import { useLocale } from '../../../hooks/useLocale';
import styles from '../Onboarding.module.scss';

export const SweepCoinTooltip = (props: { handleClick: VoidFunction }) => {
  const { t } = useTranslation();
  const { isGDPR } = useLocale();
  const sweepsPolicyUrl = isGDPR ? t('sweeps.policy.superUrl') : t('sweeps.policy.url');

  return (
    <>
      <p data-testid="onboarding-sweep-coin-tooltip-text">
        <Trans
          components={{
            intro: <span />,
            coins: (
              <span className={styles.coinImage}>
                <CrownRoundedIcon />
                <SweepCoin />
              </span>
            ),
            bold: <strong />,
            outro: <span />,
            rules: (
              <a
                className={styles.sweepsPolicyLink}
                href={`/pages/${sweepsPolicyUrl}`}
                rel="noreferrer"
                target="_blank"
              />
            ),
          }}
          i18nKey={isGDPR ? 'onboarding.playWithSuperCash' : 'onboarding.playWithSweepsCash'}
        />
      </p>
      <Button btnType="main" onClick={props.handleClick}>
        {t('onboarding.awesome')}
      </Button>
    </>
  );
};
